module.exports = __webpack_public_path__ + "img/center front length to hem.fbae1a0c.png";